import { useState } from "react";
import { LogoutContainer } from "../Logout/LogoutContainer";
import { TaskpanePresentational } from "./TaskpanePresentational";
import { useDocumentIds } from "../../Hooks/useDocumentIds";
import { useMatterData } from "../../Hooks/useMatterData";
import { assignToMatterAsync, SaveDocumentToMatterStatus, saveToMatterAsync } from "../../services/office-api";
import { TMatter } from "../../models/matter-model";
import { getMatterRetriever } from "../../services/matter-retriever";
import { SaveToMatterClickSource } from "../../helpers/MetricsHelper";

export const TaskpaneReadContainer = () => {
  const { matterId, error: matterIdError, isLoading: matterIdLoading } = useDocumentIds();
  const { data: matterData, error: matterDataError, isLoading: matterDataLoading } = useMatterData(matterId);
  const [isSavingToMatter, setIsSavingToMatter] = useState<boolean>(false);
  const [isAssigningToMatter, setIsAssigningToMatter] = useState<boolean>(false);
  const [selectedMatter, setSelectedMatter] = useState<TMatter | null>(null);

  const defaultMatter = matterData?.matter ?? selectedMatter ?? null;

  if (selectedMatter !== defaultMatter) {
    setSelectedMatter(defaultMatter);
  }

  const saveToMatterHandler = () => {
    console.info(`saveToMatterHandler: saving a new version of document`);

    setIsSavingToMatter(true);

    saveToMatterAsync(SaveToMatterClickSource.TaskpaneButton)
      .then((status: SaveDocumentToMatterStatus) => {
        setIsSavingToMatter(false);

        if (status === SaveDocumentToMatterStatus.FileIdNotFound) {
          // Special case where matterId exists, but no associated fileId was found.
          assignToMatterHandler(selectedMatter);
        }
      })
      .catch((error: unknown) => {
        setIsSavingToMatter(false);
        console.error(error);
      });
  };

  const assignToMatterHandler = (matter: TMatter | null) => {
    const matterId = matter?.matterId;

    if (!matterId) {
      console.warn("assignToMatterHandler: matterId is missing, action skipped.");
      return;
    }

    console.info(`assignToMatterHandler: assigning document to matter: ${matterId}`);

    setSelectedMatter(matter);
    setIsAssigningToMatter(true);

    assignToMatterAsync(matterId)
      .then((status: SaveDocumentToMatterStatus) => {
        setIsAssigningToMatter(false);

        if (status !== SaveDocumentToMatterStatus.Succeed) {
          // On failure, return to the list of matters
          setSelectedMatter(null);
        }
      })
      .catch((error: unknown) => {
        setIsAssigningToMatter(false);
        setSelectedMatter(null);
        console.error(error);
      });
  };

  const matterRetriever = getMatterRetriever();

  return (
    <div className="flex flex-col h-full">
      <div className="flex-1 max-h-full min-h-0">
        <TaskpanePresentational
          isLoading={matterIdLoading || matterDataLoading}
          isMatterIdFound={!matterIdError && matterId !== undefined}
          isMatterDataLoaded={!matterDataError && matterData?.matter != null}
          isAssigningToMatter={isAssigningToMatter}
          selectedMatter={selectedMatter}
          isSavingToMatter={isSavingToMatter}
          saveToMatter={saveToMatterHandler}
          assignToMatter={assignToMatterHandler}
          matterRetriever={matterRetriever}
        />
      </div>
      <div className="flex flex-col justify-end mt-auto">
        <LogoutContainer />
      </div>
    </div>
  );
};
